import { Component } from '@angular/core';
import { membersuiteInvoiceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Invoices') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteinvoice-form',
    templateUrl: './membersuiteinvoice.form.component.html'
})
export class membersuiteInvoiceFormComponent extends BaseFormComponent {
    public record!: membersuiteInvoiceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

